import { useReducer } from "react";

const useForceUpdate = () => {
  const [count, forceUpdate] = useReducer((x) => x + 1, 0);

  return { updateCount: count, forceUpdate };
};

export { useForceUpdate };
